var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconClose = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5919 12.0002L20.6702 4.92162C21.1099 4.48221 21.1099 3.76925 20.6702 3.32984C20.2304 2.89005 19.5182 2.89005 19.0785 3.32984L12.0002 10.4084L4.92154 3.32984C4.48177 2.89005 3.76959 2.89005 3.32982 3.32984C2.89006 3.76925 2.89006 4.48221 3.32982 4.92162L10.4085 12.0002L3.32982 19.0788C2.89006 19.5182 2.89006 20.2311 3.32982 20.6705C3.54971 20.8901 3.83788 21 4.12568 21C4.41348 21 4.70165 20.8901 4.92154 20.6702L12.0002 13.5916L19.0785 20.6702C19.2983 20.8901 19.5865 21 19.8743 21C20.1621 21 20.4503 20.8901 20.6702 20.6702C21.1099 20.2308 21.1099 19.5178 20.6702 19.0784L13.5919 12.0002Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-close.cc0fc59e6a78a85171136c43800bff2c.svg";